export default class Loader{
  static instance

  constructor(){
    // Check Instance
    if (Loader.instance){
      return Loader.instance
    }
    Loader.instance = this

    this.htmlLoader
    this.htmlLoaderShadow
  }

  udpateHtmlElements(){
    this.htmlLoader = document.getElementById('loader')
    this.htmlLoaderShadow = document.getElementById('loaderShadow')
  }

  close(){
    setTimeout(() => {
      this.htmlLoader.style.transitionDuration = "1000ms"
      this.htmlLoaderShadow.style.transitionDuration = "1000ms"
      this.htmlLoaderShadow.style.transitionDelay = "200ms"

      this.htmlLoader.style.clipPath = "polygon(0 0, 100% 0, 100% 0, 0 0)"
      this.htmlLoaderShadow.style.clipPath = "polygon(0 0, 100% 0, 100% 0, 0 0)"
    }, 100)
  }

  open(){
    this.htmlLoader.style.transitionDuration = "0ms"
    this.htmlLoaderShadow.style.transitionDuration = "0ms"
    this.htmlLoaderShadow.style.transitionDelay = "0ms"

    this.htmlLoader.style.clipPath = "polygon(0 0, 100% 0, 100% 100%, 0% 100%)"
    this.htmlLoaderShadow.style.clipPath = "polygon(0 0, 100% 0, 100% 100%, 0% 100%)"
  }
}